import React from 'react';
import ServicesLayout from '../../../components/ServicesLayout';
import ServiceCards from './ServiceCards';
import { isAdminUser, isDistrictAdminUser } from '../../../lib/utils';

const title = 'Karty eusług';


export default {

  path: '/service_cards',
  children: [
    {
      path: '/',
      async action(ctx) {
        const state = await ctx.store.getState();
        const isAdmin = await isAdminUser(ctx);
        let isDistrictAdmin = null;
        if (!isAdmin) {
          isDistrictAdmin = await isDistrictAdminUser(ctx);
          if (!isDistrictAdmin) {
            return { redirect: '/' };
          }
        }
        return {
          title,
          chunk: 'ServiceCards',
          component: <ServicesLayout isAdmin><ServiceCards title={title} isDistrictAdmin={isDistrictAdmin} user={state.user} /></ServicesLayout>,
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/admin/service_cards/index.js